<script>
import LandingLayout from '@/Shared/LandingLayout.vue';
import SmartBreadcrumbs from '@/components/SmartBreadcrumbs.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import SociogramSurveyShowPage from '../../Teacher/Sociograms/partials/SociogramSurveyShowPage.vue';

export default {
    props: {
        meta: Object,
        nexa: Object,
    },
    components: {
        SociogramSurveyShowPage,
        PanelPage,
        SmartBreadcrumbs,
    },
    layout: LandingLayout,
    mounted() {
        this.$i18n.locale = this.meta.locale;
    },
};
</script>
<template>
    <PanelPage>
        <template v-slot:title>
            <div class="bg-gray-100 mb-2">
                <div class="lg:mx-auto lg:max-w-7xl lg:px-8 py-2">
                    <SmartBreadcrumbs
                        type="InertiaLink"
                        :pages="[
                            {
                                name: $t('landing.user_roles'),
                                href: meta.links.landing,
                            },
                            {
                                name: $tc('messages.teachers', 2),

                                href: meta.links.teachers,
                            },

                            {
                                name: $t('messages.nexa'),
                                href: meta.links.nexa,
                            },
                        ]"
                    />
                </div>
            </div>
        </template>
        <SociogramSurveyShowPage :sociogram-survey="nexa.sociogram" :meta="nexa.meta" />
    </PanelPage>
</template>
